const MuiCssBaseline = {
  styleOverrides: {
    body: {
      overscrollBehavior: 'none',
    },
    html: {
      overscrollBehavior: 'none',
    },
  },
};

export default MuiCssBaseline;
